import React, { FC, useState } from 'react'
import { Box, Typography } from 'transfix-ui/core'
import { useBreakpointContext } from 'utils/context/BreakpointContext'
import { DedicatedLanesResponse } from 'apps/marketplace/apiTypes/dedicatedLanes'
import { Card, Table, TableBody } from 'transfix-ui'
import { DedicatedLanesOfferRow } from './DedicatedLanesOfferRow'
import { DedicatedLanesOfferRowMobile } from './DedicatedLanesOfferRowMobile'
import { ExpandLaneOffers } from './ExpandLaneOffers'

interface ILaneOffersTableProps {
  dedicatedLanes: DedicatedLanesResponse[]
}

export const LaneOffersTable: FC<ILaneOffersTableProps> = ({ dedicatedLanes = [] }) => {
  const { isMobile } = useBreakpointContext()
  const [areAllOffersShown, setAreAllOffersShown] = useState<boolean>(false)
  const clickHandlerShowMoreMatches = () => setAreAllOffersShown(true)
  const [firstOffer] = dedicatedLanes || []
  return (
    <Box>
      <Box paddingLeft={3}>
        <Typography variant='subtitle1'>Dedicated lanes</Typography>
        <Typography variant='body2'>
          Place a bid to get priority access to loads as a dedicated carrier.
        </Typography>
      </Box>
      <Card dataTest='dedicated-lanes-card' className='pa0 ma4'>
        <Box>
          <Table>
            <></>
            <TableBody>
              {dedicatedLanes.length > 0 && !isMobile && (
                <DedicatedLanesOfferRow key={firstOffer?.id} dedicatedLane={firstOffer} />
              )}
              {dedicatedLanes.length > 0 && isMobile && (
                <DedicatedLanesOfferRowMobile key={firstOffer?.id} dedicatedLane={firstOffer} />
              )}
              {areAllOffersShown &&
                dedicatedLanes.slice(1).map(dl => {
                  if (isMobile) {
                    return <DedicatedLanesOfferRowMobile key={dl?.id} dedicatedLane={dl} />
                  }
                  return <DedicatedLanesOfferRow key={dl?.id} dedicatedLane={dl} />
                })}
            </TableBody>
          </Table>
          {!areAllOffersShown && dedicatedLanes.length > 1 && (
            <ExpandLaneOffers
              dedicatedLanes={dedicatedLanes}
              onClickShowMoreMatches={clickHandlerShowMoreMatches}
            />
          )}
        </Box>
      </Card>
    </Box>
  )
}
